






















































































import axios, { AxiosError } from 'axios';
import { Component, Watch } from 'vue-property-decorator';

import DialogBase from '@/components/common/DialogBase';
import loginUser from '@/store/modules/LoginUserModule';

@Component({
  components: {},
})
export default class UserInfoDialog extends DialogBase {
  //private userNameAndFontSize: [string | null, number] = [null, 0.0];
  private userName: string | null = null;
  private fontSize = 0.0;
  // フォントサイズの最大値&最小値
  // この制限はボタンに紐づけたメソッドとスライダー両方で使うので、
  // 範囲変更時に一部の反映を忘れないように変数に入れて使う。
  private fontSizeMin = 1;
  private fontSizeMax = 1500;
  private imageUrl: string | null = null;

  private loading = false;

  @Watch('userName')
  private updateFontsize() {
    // 名前が変わったらフォントサイズは再計算
    this.resetSize();
  }

  @Watch('value')
  protected onValueChanged(newVal: boolean): void {
    this.init();
    this.innerValue = newVal;
  }

  private onUpdateFontSize() {
    this.imageUrl =
      '/stamp?userName=' + this.userName + '&fontSize=' + this.fontSize;
  }

  private resetSize(): void {
    const res = axios
      .get('/stamp/recalculate?userName=' + this.userName)
      .then(response => {
        this.fontSize = response.data;
        this.onUpdateFontSize();
      })
      .catch((error: AxiosError) => {
        console.error(error);
      });
  }
  private async onUpdate() {
    if (!this.userName) {
      // formが空文字の場合は"更新"がdisableになっているのでありえないはず
      this.$toast.error('空文字では登録できません');
      return;
    }
    this.loading = true;
    const res = await axios
      .put('/api/login_user/info', {
        name: this.userName,
        fontSize: this.fontSize,
      })
      .catch((error: AxiosError) => {
        console.error(error);
        return null;
      });
    this.loading = false;
    if (res) {
      this.$toast.success('ユーザー情報を更新しました。');
      await loginUser.getLoginUser();
      this.innerValue = false;
    } else {
      this.$toast.error('ユーザー情報の更新に失敗しました。');
    }
  }

  private async onStampSizeUp() {
    const newSize = this.fontSize + 20.0;
    if (newSize > this.fontSizeMax) {
      this.fontSize = this.fontSizeMax;
    } else {
      this.fontSize = newSize;
    }
    this.imageUrl =
      '/stamp?userName=' + this.userName + '&fontSize=' + this.fontSize;
  }

  private async onStampSizeDown() {
    const newSize = this.fontSize - 20.0;
    if (newSize < this.fontSizeMin) {
      this.fontSize = this.fontSizeMin;
    } else {
      this.fontSize = newSize;
    }
    this.imageUrl =
      '/stamp?userName=' + this.userName + '&fontSize=' + this.fontSize;
  }

  private mounted() {
    this.init();
  }

  private init() {
    this.userName = loginUser.loginUser?.name ?? null;
    this.fontSize = loginUser.loginUser?.fontSize ?? 0.0;
    this.imageUrl =
      '/stamp?userName=' +
      this.userName +
      '&fontSize=' +
      this.fontSize.toString;
  }
}
